import "@/assets/css/main.css";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import SPCHamburger from "@/plugins/SPCHamburger";
import SPCScroller from "@/plugins/SPCScroller";
import SPCSlider from "@/plugins/SPCSlider";
// import XGEN from '@/plugins/XGEN';
import "@/assets/css/tailwind.css";
import VueMeta from "vue-meta";

Vue.config.productionTip = false;

Vue.use(SPCSlider);
Vue.use(SPCScroller);
Vue.use(SPCHamburger);
// Vue.use(XGEN);
Vue.use(VueMeta, {
	// optional pluginOptions
	refreshOnceOnNavigation: true,
});

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
